var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-grow-1"},[_c('div',{ref:"agriEcoDev",style:({ width: '100%', height: _vm.chartHeight + 'px' }),attrs:{"id":"EChartTemplate"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }